<div class="app-shell">
  <app-cabecalho-marca
    [logo]="logo"
    [iniciais]="iniciais"
    [nome]="nome"
    [agora]="agora">
  </app-cabecalho-marca>

  <main class="container py-4">
    <app-navegacao-administrativa
      [aba]="aba"
      [adminGlobal]="adminGlobal"
      [ajustesPendentes]="ajustesPendentes"
      [feriasPendentes]="feriasPendentes"
      (selecionar)="selecionar.emit($event)"
      (menu)="menu.emit()"
      (sair)="sair.emit()">
    </app-navegacao-administrativa>

    <app-alerta-mensagem [mensagem]="mensagem"></app-alerta-mensagem>
    <ng-content></ng-content>
  </main>
</div>
